module.exports = __webpack_public_path__ + "static/newhome-e22e9b2fc7dcf91deac95b29354cd7a1.webp";